import { createAction, handleActions } from 'redux-actions';

const setFormValue = createAction("MODALS/SUPPLIER_ITEM/SET_FORM_VALUE", (key, value) => ({ key, value }));
const resetForm = createAction("MODALS/SUPPLIER_ITEM/RESET_FORM");
const loadForm = createAction("MODALS/SUPPLIER_ITEM/LOAD_FORM");

const defaultState = {
  name: '',
  description: '',
  item_code: '',
  unit_of_measure: 'each',
  unit_price: null,
  currency: 'GBP',
  tax_rate: 20,
  lead_time_days: null,
  minimum_order_quantity: null,
  category: null,
  manufacturer: '',
  add_to_paint_list: false,
  paint_coats: null,
  paint_coverage_per_litre: null,
  paint_carbon_per_litre: null,
  notes: '',
  active: true,
  cost_change_reason: '',
};

const reducer = handleActions(
  {
    [setFormValue]: (state, action) => ({ ...state, [action.payload.key]: action.payload.value }),
    [resetForm]: () => defaultState,
    [loadForm]: (state, action) => ({ ...state, ...action.payload }),
  },
  defaultState
);

export { setFormValue, resetForm, loadForm, reducer };
